module.exports = __webpack_public_path__ + "img/27.07409f6c.svg";